export const IconMoon = () => {
  const pixelSize = 24;

  return (
    <svg
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M11.18 1.506a1 1 0 0 1 .125 1.063 8.696 8.696 0 0 0-.855 3.776 8.735 8.735 0 0 0 10.829 8.482 1 1 0 0 1 1.14 1.404 10.736 10.736 0 0 1-9.683 6.094c-5.928 0-10.734-4.806-10.734-10.735 0-5.043 3.477-9.272 8.163-10.424a1 1 0 0 1 1.015.34Zm-2.43 2.31a8.735 8.735 0 1 0 10.787 13.258 10.33 10.33 0 0 1-.352.006c-5.929 0-10.735-4.807-10.735-10.735 0-.87.104-1.718.3-2.529Z"
        fill="currentColor"
      />
    </svg>
  );
};
